import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "testimonials-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = {
  key: 1,
  class: "testimonials-grid"
}
const _hoisted_5 = { class: "testimonial-card" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "stars" }
const _hoisted_8 = { class: "client-info" }
const _hoisted_9 = { class: "client-photo" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "client-name" }

import { ref, onMounted } from 'vue';
import { toRaw } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TestimonialsSection',
  setup(__props) {

const HYGRAPH_ENDPOINT = process.env.VUE_APP_HYGRAPH_URL;



const testimonials = ref([]);
const loading = ref(true);

const fetchTestimonials = async () => {
  const query = `
    query GetDepoimentos {
      testimonials {
        id
        patientName
        text
        rating
        image { url }
      }
    }
  `;

  try {
    const response = await fetch(HYGRAPH_ENDPOINT!, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query })
    });
    
    const { data } = await response.json();
    //console.log(JSON.stringify(data,null,2));
    if (data && data.testimonials) {
      testimonials.value = data.testimonials.map((item: any) => ({
        id: item.id,
        name: item.patientName, 
        text: item.text,
        rating: item.rating || 5,
        imageUrl: item.image?.url || 'https://via.placeholder.com/100'
      }));
    }   
  } catch (error) {
    console.error("Erro ao buscar depoimentos:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(fetchTestimonials);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "section-title" }, "O que dizem meus pacientes", -1)),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Carregando depoimentos..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testimonials.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "testimonial-wrapper"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "quote-mark" }, "“ ”", -1)),
                  _createElementVNode("p", {
                    class: "testimonial-text",
                    innerHTML: item.text
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rating, (n) => {
                      return (_openBlock(), _createElementBlock("span", { key: n }, "★"))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: item.imageUrl,
                      alt: item.name
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(item.name), 1)
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})